import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PageEvent} from '@angular/material/paginator';
import { BehaviorSubject } from 'rxjs';
import { LoanWheelInventoryService } from '../../../services/loaner-wheel-inventory.service';
import { InventoryHistory, ModelType, TireSize } from '../../../models/loaner-wheel-inventory';
import { LoanerWheelInventoryState } from '../../../store/state/loaner-wheel-inventory.state';
import { Store, select } from '@ngrx/store';
import { SelectModelTypes, SelectTireSizes } from '../../../store/selectors/loaner-wheel-inventory.selector';
import { I18nService } from '../../../../shared/services/i18n.service';

@Component({
  selector: 'app-inventory-history',
  templateUrl: './inventory-history.component.html',
  styleUrls: ['./inventory-history.component.scss']
})
export class InventoryHistoryComponent implements OnInit {
  datasource: BehaviorSubject<any> = new BehaviorSubject([]);

  displayedColumns = ['modifiedon', 'modifiedby', 'location', 'model', 'tiresize', 'prevquantity', 'updatedquantity'];
  pageSizeOptions: number[] = [10, 25, 50, 100, 250];
  pageIndex = 0;
  pageSize = 10;
  total = 0;

  supplierCode: string;
  inventoryHistoryList: InventoryHistory[];
  locationAddress: any[] = [];
  models: ModelType[] = [];
  tireSizes: TireSize[] = [];

  constructor(public dialogRef: MatDialogRef<InventoryHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private inventoryService: LoanWheelInventoryService,
    public translateService: I18nService,
    private store: Store<LoanerWheelInventoryState>) {
    this.supplierCode = dialogData.supplierCode;
    this.locationAddress = dialogData.locations;
  }

  ngOnInit() {
    this.loadResources();
  }

  loadResources() {
    this.store.pipe(select(SelectModelTypes)).subscribe(types => {
      if (types && types.length > 0) {
        this.models = types;
      }
    });
    this.store.pipe(select(SelectTireSizes)).subscribe(sizes => {
      if (sizes && sizes.length > 0) {
        this.tireSizes = sizes;
      }
    });
    this.inventoryHistoryList = [];
    this.inventoryService.getInventoryHistoryBySupplier(this.supplierCode).subscribe(history => {
      this.inventoryHistoryList.unshift(...history);
      this.loadGrid();
    });
  }

  loadGrid() {
    this.total = this.inventoryHistoryList.length;
    const skip = this.pageIndex * this.pageSize;
    const take = (this.pageIndex + 1) * this.pageSize;
    this.datasource.next(this.inventoryHistoryList.slice(skip, take));
  }

  onPageChange(pageChange: PageEvent): void {
    const { pageIndex, pageSize } = pageChange;
    this.pageIndex = pageIndex;
    this.pageSize = pageSize;
    this.loadGrid();
  }

  onClose(): void {
    this.dialogRef.close();
  }

  getFullLocation(id: string): string {
    let loc = null;
    if (this.locationAddress && this.locationAddress.length > 0) {
      loc = this.locationAddress.find(x => x.locationId == id).address;
    }
    return loc;
  }

  getModelName(id: number): string {
    let model = null;
    if (this.models && this.models.length > 0) {
      let modelInfo = this.models.find(t => t.id == id);
      model = modelInfo.variantProviderText ? modelInfo.name +" - "+ modelInfo.variantProviderText : modelInfo.name;
    }
    return this.translateService.get(model);
  }

  getTireSize(id: number): string {
    let tire = null;
    if (this.tireSizes && this.tireSizes.length > 0) {
      tire = this.tireSizes.find(t => t.id == id).name;
    }
    return this.translateService.get(tire);
  }

  getTimestamp(date: string){
    return new Date(date).toUTCString();
  }
}
